// app/javascript/modules/ferias/form_fracionamento.js
// Gerencia o toggle de fracionamento de férias quando existe um checkbox explícito
// (movimentacoes_pessoal_fracionar_ferias). Quando o checkbox não está presente,
// o módulo é no-op — a lógica de show/hide é tratada por form_periodos.js.

export function initFeriasFracionamento(form) {
  const checkbox = form.querySelector('#movimentacoes_pessoal_fracionar_ferias')

  // Sem checkbox → modo auto (períodos controlados por form_periodos.js)
  if (!checkbox) {
    return {
      apply() {},
      destroy() {},
    }
  }

  const periodo2 = form.querySelector('[data-ferias-periodo="2"]')
  const periodo3 = form.querySelector('[data-ferias-periodo="3"]')

  function clearPeriodo(iniSel, fimSel) {
    const ini = form.querySelector(iniSel)
    const fim = form.querySelector(fimSel)
    if (ini) ini.value = ''
    if (fim) fim.value = ''
  }

  function setDisabled(val) {
    checkbox.disabled = val
    const label = form.querySelector('label[for="movimentacoes_pessoal_fracionar_ferias"]')
    if (label) label.style.opacity = val ? '0.5' : '1'
  }

  function apply() {
    if (checkbox.checked) {
      periodo2?.classList.remove('hidden')
      periodo3?.classList.remove('hidden')
    } else {
      periodo2?.classList.add('hidden')
      periodo3?.classList.add('hidden')
      clearPeriodo('#params_inicio_ferias_2', '#params_termino_ferias_2')
      clearPeriodo('#params_inicio_ferias_3', '#params_termino_ferias_3')
    }
  }

  function onTotalChanged(e) {
    const { total } = e.detail
    if (!checkbox.checked) return
    if (total >= 30) {
      periodo3?.classList.add('hidden')
      clearPeriodo('#params_inicio_ferias_3', '#params_termino_ferias_3')
    } else {
      periodo3?.classList.remove('hidden')
    }
    setDisabled(total >= 30)
  }

  checkbox.addEventListener('change', apply)
  form.addEventListener('ferias:total-changed', onTotalChanged)

  return {
    apply,
    destroy() {
      checkbox.removeEventListener('change', apply)
      form.removeEventListener('ferias:total-changed', onTotalChanged)
    },
  }
}
